module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Tournament Awards","wins":"wins"},"es":{"title":"Premios del Torneo","wins":"gana"}}')
  delete Component.options._Ctor
}
